'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var useTheme = {};

exports.__exports = useTheme;
